import { useQueries } from '@tanstack/react-query';
import { setupApi } from '@/api/setup';
import { hrApi } from '@/api/hr';

const FIVE_MIN = 5 * 60 * 1000;

/**
 * Bundled lookups used across staff forms.
 */
export function useHrLookups() {
  const queries = useQueries({
    queries: [
      { queryKey: ['setup', 'lookups', 'genders', 'active'], queryFn: () => setupApi.listLookup('genders', true), staleTime: FIVE_MIN },
      { queryKey: ['setup', 'lookups', 'departments', 'active'], queryFn: () => setupApi.listLookup('departments', true), staleTime: FIVE_MIN },
      { queryKey: ['setup', 'lookups', 'employment-types', 'active'], queryFn: () => setupApi.listLookup('employment-types', true), staleTime: FIVE_MIN },
      { queryKey: ['setup', 'cities', 'active'], queryFn: () => setupApi.listCities(true), staleTime: FIVE_MIN },
      { queryKey: ['hr', 'designations', 'active'], queryFn: () => hrApi.listDesignations(true), staleTime: FIVE_MIN },
    ],
  });
  const [genders, departments, employmentTypes, cities, designations] = queries;
  return {
    genders: genders.data ?? [],
    departments: departments.data ?? [],
    employmentTypes: employmentTypes.data ?? [],
    cities: cities.data ?? [],
    designations: designations.data ?? [],
    isLoading: queries.some((q) => q.isLoading),
  };
}
